/*
 * GUARDIA SULLA CONFEZIONE REGALO - 18-09-2026
 * ---------------------------------------------------------------------------
 *
 * PERCHE' ESISTE
 * La confezione regalo e' un prodotto vero, con un prezzo e una pagina sua.
 * Deve restare vendibile, altrimenti la spunta nel carrello smette di
 * funzionare: un prodotto non pubblicato sul Negozio online Shopify non lo
 * lascia aggiungere al carrello, e toglierlo dal canale spegnerebbe anche la
 * spunta legittima. Ma proprio perche' e' vendibile, fino a ieri chiunque
 * aprisse la sua pagina poteva comprarla DA SOLA.
 *
 * Il 17 settembre alle 15:30 e il 18 alle 02:29 due carrelli abbandonati
 * hanno contenuto soltanto quella, 5,99 euro, con indirizzi segnaposto a
 * Portland e a Vancouver e due email gmail generate a macchina. E' la forma
 * classica della prova di carte rubate: si cerca l'articolo piu' economico
 * del negozio, possibilmente senza una spedizione credibile da inventare, e
 * ci si passano sopra le carte una dopo l'altra per vedere quali sono ancora
 * vive. Nessuna delle due e' andata a buon fine, ma la porta era aperta.
 *
 * COME DISTINGUE UNA CONFEZIONE BUONA DA UNA CATTIVA
 * Non serve indovinare, perche' la distinzione e' gia' scritta nel carrello.
 * Ogni confezione aggiunta con la spunta porta con se' la proprieta' nascosta
 * _variant_id, che snippets/gift-wrap.liquid usa per ricordare A QUALE CAPO
 * la confezione si riferisce. Una confezione aggiunta dalla pagina prodotto
 * quella proprieta' non ce l'ha e non puo' averla: nessuna spunta l'ha
 * scritta.
 *
 * La regola e' quindi binaria, senza soglie e senza euristiche:
 *   riga di confezione il cui _variant_id manca, oppure punta a una variante
 *   che nel carrello non c'e' -> si toglie.
 *
 * Niente falsi positivi possibili: una confezione legittima ha sempre il
 * gancio, e il capo a cui punta e' per forza nel carrello, altrimenti la
 * spunta non sarebbe mai comparsa.
 *
 * EFFETTO COLLATERALE, VOLUTO
 * Toglie anche le confezioni rimaste orfane per motivi onesti: il cliente
 * aveva spuntato la confezione su un maglione e poi ha tolto il maglione dal
 * carrello. Prima la confezione restava li' e si pagava una scatola per
 * niente. Adesso se ne va insieme al capo.
 *
 * QUANDO GIRA
 * Due momenti, nessuno dei quali rallenta il primo disegno della pagina:
 *  - all'evento 'load', quindi a pagina gia' formata;
 *  - a ogni 'cart:refresh', che e' l'evento con cui il codice su misura
 *    annuncia che il carrello e' cambiato. E' li' che serve davvero, perche'
 *    e' il momento subito dopo un'aggiunta.
 *
 * COME SI RIDISEGNA IL CARRELLO DOPO UNA RIMOZIONE
 * Provato il 18-09-2026 in anteprima: emettere 'cart:refresh' NON basta a far
 * ridisegnare la pagina carrello di Prestige 11, che resta a mostrare la riga
 * appena tolta mentre il carrello vero e' gia' vuoto. Si ricarica quindi la
 * pagina, ma solo dove la differenza si vede - pagina carrello o tendina
 * aperta - e solo dopo aver VERIFICATO rileggendo il carrello che la riga sia
 * sparita davvero. La verifica non e' pignoleria: senza, una rimozione che
 * fallisse sempre farebbe ricaricare la pagina all'infinito, perche' il
 * contatore dei tentativi riparte da zero a ogni caricamento. C'e' comunque
 * un secondo freno in sessionStorage, che ammette al massimo due ricariche
 * per sessione.
 *
 * QUELLO CHE NON FERMA, E VA SAPUTO
 * Una chiamata diretta a /cart/add.js seguita da un salto dritto al checkout
 * non passa mai da qui, perche' nessuna nostra riga di codice viene eseguita.
 * Contro quella servirebbe una validazione lato checkout, cioe' Shopify
 * Functions, cioe' il piano Plus: strada gia' esplorata e chiusa il
 * 13-09-2026. Questa guardia copre il percorso normale - pagina prodotto,
 * carrello, checkout - che e' quello che usano gli strumenti automatici che
 * guidano un browser vero.
 *
 * SE UN DOMANI CAMBIA IL PRODOTTO
 * L'handle sta in HANDLE qui sotto e deve restare uguale a gift_box_handle
 * di snippets/gift-wrap.liquid. Se cambia li' e non qui, la guardia smette
 * di riconoscere la confezione e non toglie piu' niente: in silenzio, senza
 * errori a schermo.
 */

(function () {
  'use strict';

  var HANDLE = 'dalle-piane-cashmere-gift-box';
  var CHIAVE_RICARICHE = 'guardia-confezione-ricariche';
  var RICARICHE_MASSIME = 2;

  var inCorso = false;
  var giri = 0;
  var GIRI_MASSIMI = 3;

  function leggiCarrello() {
    return fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (risposta) {
      if (!risposta.ok) {
        throw new Error('carrello non leggibile');
      }
      return risposta.json();
    });
  }

  function togliRiga(chiave) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: chiave, quantity: 0 })
    });
  }

  // Le varianti dei capi presenti, cioe' i possibili bersagli legittimi di una
  // confezione. Le righe di confezione non contano: una confezione agganciata
  // a un'altra confezione non ha senso.
  function orfaneIn(carrello) {
    if (!carrello || !carrello.items || carrello.items.length === 0) {
      return [];
    }
    var varianti = {};
    carrello.items.forEach(function (riga) {
      if (riga.handle !== HANDLE) {
        varianti[String(riga.variant_id)] = true;
      }
    });
    return carrello.items.filter(function (riga) {
      if (riga.handle !== HANDLE) {
        return false;
      }
      var legame = riga.properties ? riga.properties._variant_id : null;
      return !legame || !varianti[String(legame)];
    });
  }

  function laDifferenzaSiVede() {
    if (window.location.pathname.indexOf('/cart') === 0) {
      return true;
    }
    return !!document.querySelector(
      'cart-drawer[open], cart-drawer[aria-hidden="false"], dialog[open] cart-drawer'
    );
  }

  function ricaricaSePossibile() {
    var fatte = 0;
    try {
      fatte = parseInt(window.sessionStorage.getItem(CHIAVE_RICARICHE) || '0', 10) || 0;
    } catch (e) {
      // sessionStorage negato (navigazione privata, cookie bloccati): senza il
      // freno si preferisce non ricaricare affatto.
      return;
    }
    if (fatte >= RICARICHE_MASSIME) {
      return;
    }
    try {
      window.sessionStorage.setItem(CHIAVE_RICARICHE, String(fatte + 1));
    } catch (e) {
      return;
    }
    window.location.reload();
  }

  function controlla() {
    if (inCorso || giri >= GIRI_MASSIMI) {
      return;
    }
    inCorso = true;

    leggiCarrello()
      .then(function (carrello) {
        var orfane = orfaneIn(carrello);
        if (orfane.length === 0) {
          return false;
        }

        giri += 1;

        // In sequenza e non in parallelo: il carrello di Shopify e' uno solo e
        // due chiamate simultanee a /cart/change.js possono sovrascriversi.
        var catena = Promise.resolve();
        orfane.forEach(function (riga) {
          catena = catena.then(function () {
            return togliRiga(riga.key);
          });
        });

        // Rilettura di controllo: si ridisegna solo se le righe sono sparite
        // davvero.
        return catena.then(leggiCarrello).then(function (dopo) {
          return orfaneIn(dopo).length === 0;
        });
      })
      .then(function (ripulito) {
        inCorso = false;
        if (!ripulito) {
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (laDifferenzaSiVede()) {
          ricaricaSePossibile();
        }
      })
      .catch(function () {
        // Un carrello non leggibile non deve rompere la pagina: si riprova al
        // prossimo cart:refresh.
        inCorso = false;
      });
  }

  document.addEventListener('cart:refresh', function () {
    window.setTimeout(controlla, 0);
  });

  if (document.readyState === 'complete') {
    controlla();
  } else {
    window.addEventListener('load', controlla);
  }
})();